import type {Hotel} from '@/redux/v1/hotels/list/models';

type RatingData = {
  score: number;
  reviewCount: number;
  recommendationRate: number | null;
};

export const getRatingData = ({
  hotelOffer,
}: {
  hotelOffer: Hotel | null;
}): RatingData | null => {
  if (
    hotelOffer?.rating &&
    hotelOffer.rating.rating >= 0 &&
    hotelOffer.rating.count >= 0
  ) {
    return {
      score: hotelOffer.rating.rating,
      reviewCount: hotelOffer.rating.count,
      recommendationRate: hotelOffer.rating.recommendationRate,
    };
  }

  return null;
};
